import { render } from "./trainingCompletion.vue?vue&type=template&id=d04d0e08&ts=true"
import script from "./trainingCompletion.vue?vue&type=script&lang=ts"
export * from "./trainingCompletion.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__